import {
  authHeader,
  config,
  options,
  handleResponse,
  handleError
} from "../helpers";

export const notificationService = {
  getAll
};
export const userService = {
  getCompanyInfo
};
function getAll(params) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const serviceurl = options(
    config.flukeIotApiUrl +
      "/session/" +
      params.sessionId +
      "/email/" +
      params.emailId +
      "/notification/counts"
  );
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}

function getCompanyInfo(email) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };
  const serviceurl = options(config.apiUrl + "/activationaddress/" + email);
  const url = serviceurl;
  return fetch(url, requestOptions).then(handleResponse, handleError);
}
